module.exports = __webpack_public_path__ + "img/gas-pump-slash.9b7c7d2f.svg";